import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const audiomack: MusicService = {
  id: 'audiomack',
  name: 'Audiomack',
  shortName: 'Audiomack',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#FFA200',
    label: '#FFA200',
    background: '#1C1C1CB8',
  },
  importerID: ImporterID.Audiomack,
  musicAPIID: MusicAPIIntegrationID.Audiomack,
  linkType: 'audiomack',
  limits: {
    matchingTracks: 10,
    addingTracks: 20,
    matchingAlbums: 10,
    addingAlbums: 20,
    matchingArtists: 10,
    addingArtists: 20,
  },
  assets: {
    logo: { light: 'audiomack-light.svg', dark: 'audiomack-dark.svg' },
    logoPadding: { light: 'audiomack-light-padding.svg', dark: 'audiomack-dark-padding.svg' },
    logoColor: { light: 'audiomack-color-light.svg', dark: 'audiomack-color-dark.svg' },
    logoColorPadding: {
      light: 'audiomack-color-light-padding.svg',
      dark: 'audiomack-color-dark-padding.svg',
    },
    logoOnBackground: 'audiomack-dark.svg',
  },
  whatIsDescription: musicServiceMessages.audiomackWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: false,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: true,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: true,
    doesSupportRemovingArtistsFromLibrary: true,
    doesSupportSearchByISRC: false,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: true,
    doesReturnUserCountry: true,
    maxLimit: 50,
  },
};
